import React, {useEffect, useRef, useState} from "react";
import axiosInstant from "../libs/axiosInstant";
import {useForm} from "react-hook-form";
import {useMutation, useQuery} from "react-query";
import Avatar from "./Avatar";
import numeral from "numeral";
import {useSelector} from "react-redux";

function MemberModal({ setRecipient }) {

    const { config: {compose} } = useSelector((state) => state.mailBox)

    const loadSelectBoxes = async () => {
        const { data } = await axiosInstant.get('/inbox/member_options');
        return data;
    }
    const m_opts = useQuery(['member_options'], () => loadSelectBoxes())

    const submitForm = async (formData) => {
        const {data} = await axiosInstant.post('/inbox/members', formData); // Replace with your API endpoint
        return data;
    }

    const {register, getValues, handleSubmit, formState: {errors}} = useForm();

    // Set up the mutation for form submission
    const mutation = useMutation(submitForm, {
        onSuccess: (data) => {
            //console.log('Form submitted successfully:', data);
            // Perform additional actions like showing success message
        },
        onError: (error) => {
            console.error('Error submitting form:', error);
        },
    });

    // Handle form submission
    const onSubmit = (data) => {
        mutation.mutate(data);
    }

    const [members, setMembers] = useState([]);
    const handleSelectMember = (ele, row) => {
        if(members.find((m) => m.id === row.id))
            setMembers(members.filter((m) => m.id !== row.id));
        else
        setMembers([...members, row]);
    }

    const handlePaging = (page) => {
        let data = getValues();
        data.page = page;
        mutation.mutate(data)
    }
    const handleCheckAll = (e) => {
        const { checked } = e.target;
        if(checked) {
            const excludeIds = members?.map((em) => em.id);
            setMembers([...members, ...mutation.data?.rows.filter(member => !excludeIds.includes(member.id))]);
            //setMembers([...members, ...mutation.data?.rows]);
        }else {
            const excludeIds = mutation.data?.rows.map((em) => em.id);
            setMembers(members.filter(member => !excludeIds.includes(member.id)));
        }
    }

    const handleConfirm = (e) => {
        setRecipient(members);
    }

    return (
        <div className="modal fade" id="memberModal" tabIndex="-1" aria-labelledby="memberModalLabel" aria-hidden="true">
            
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-header" style={{ backgroundColor: compose.bgColor, color: compose.color}}>
                            <h5 className="modal-title" id="memberModalLabel">Chose Recipient's</h5>
                            <a className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i
                                className="ri-close-line"></i></a>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12 form-group">
                                    <div className="form-floating mb-2">
                                        <input type="text" {...register('name')} className="form-control" id="name" placeholder="Company/Member"/>
                                        <label htmlFor="name">Company/Member</label>
                                    </div>
                                </div>
                            </div>


                            <div className="row justify-content-center">
                                {m_opts.isFetched && m_opts?.data &&
                                    m_opts.data?.map((item, key) => {
                                        return <div key={key} className="col-lg-4 col-md-6 form-group mb-2">
                                            <div className="form-floating">
                                                {item.options &&
                                                <select className="form-select" id={`floating${item.name}`} {...register(item.name)}>
                                                    <option value="">All {item.title}</option>
                                                    {item.options.map((opt, i) => <option key={i} value={opt.id}>{opt.title}</option>)}
                                                </select>
                                                }
                                                {!item.options &&
                                                    <input type="text" {...register(item.name)} className="form-control" id={`floating${item.name}`} placeholder={item.title}/>
                                                }
                                                <label htmlFor={`floating${item.name}`}>{item.title}</label>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                            <div className="d-flex justify-content-center">
                                <button type="submit" className="btn btn-primary  pt-1 pb-1"
                                        disabled={mutation.isLoading || !m_opts.isFetched}
                                        style={{ backgroundColor: compose.bgButton,borderColor: compose.bgButton, color: compose.colorButton}}>
                                    <i className="ri-search-2-line"/> &nbsp;
                                    {mutation.isLoading ? 'Searching...' : 'Search'}
                                </button>
                            </div>

                            {mutation.isSuccess &&
                                <>
                                    <hr className="sm"/>
                                    <div className="card p-2 mb-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="">
                                                <input className="form-check-input check-all-member p-2" type="checkbox"
                                                       id="gridCheck" onClick={handleCheckAll}/>
                                                <label className="form-check-label" htmlFor="gridCheck">
                                                    <div><small>Choose All Member</small></div>
                                                </label>
                                            </div>
                                            <div className="d-none d-sm-block">
                                                {members.length > 0 &&
                                                    <b>Selected: {numeral(members.length).format('0,0')}</b>
                                                }
                                            </div>
                                            <div>
                                                <div className="ms-auto d-flex align-items-center">
                                                    {mutation?.data?.meta &&
                                                        <div className="mailbox-option p-0">
                                                            <span>{`${numeral(mutation.data.meta.from).format('0,0')}-${numeral(mutation.data.meta?.to).format('0,0')} of ${numeral(mutation.data.meta.total).format('0,0')}`}</span>
                                                            <a onClick={() => handlePaging(mutation?.data.meta.prev_page)}
                                                               className="pager prev"><i
                                                                className="ri-arrow-left-s-line"></i></a>
                                                            <a onClick={() => handlePaging(mutation.data.meta.next_page)}
                                                               className="pager next"><i
                                                                className="ri-arrow-right-s-line"></i></a>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row g-2 member-list">
                                        {!mutation.isLoading && mutation?.data?.rows?.map((row, i) => (
                                            <div className="col-xl-3 col-lg-4 col-md-6 col-12" key={i}>
                                                <div className={`card p-2 member-card ${members?.find((mem) => mem.id === row.id) ? 'selected' : ''}`} onClick={(el) => handleSelectMember(el, row)}>
                                                    <div className="d-flex align-items-center">
                                                        <div className="mail-avatar"><Avatar row={row}/></div>
                                                        <div className="mailcontent-sender text-truncate clamp-text">
                                                            <h6>{row.display_name}</h6>
                                                            <p>{row.member_type}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            }
                        </div>
                        <div className="modal-footer p-1">
                            <small className="">
                                {members.length > 0 &&
                                    <span>Selected Recipient's:<b> {numeral(members.length).format('0,0')}</b></span>
                                }
                            </small>
                            <button type="button" className="btn btn-primary pt-1 pb-1" data-bs-dismiss="modal" onClick={handleConfirm}
                                    disabled={members.length === 0}
                                    style={{ backgroundColor: compose.bgButton,borderColor: compose.bgButton, color: compose.colorButton}}
                            >
                                Confirm
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default MemberModal;